import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import {connect} from 'react-redux';
import {Icon} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import {getDataAttribute, getWindowLocationOrigin} from 'epic-common/src/browser';
import getCurrentLocale from '../../utils/Utils';
import Message, {getMessage} from '../common/Message';
import styles from './Locale.pcss';

const mapStateToProps = state => ({
    locale: state.getIn(['localization', 'locale']),
    messages: state.getIn(['localization', 'messageProperties']),
    supportedLocales: state.getIn(['localization', 'supportedLocales']).toJS()
});

const mapDispatchToProps = () => ({});

class Locale extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        supportedLocales: PropTypes.array,
        locale: PropTypes.string
    };

    onClick = e => {
        const index = getDataAttribute(e.currentTarget, 'index');
        if (!index) return;
        const locale = this.props.supportedLocales[index];
        if (locale && locale.onClick && typeof locale.onClick === 'function') {
            locale.onClick(e);
        }
    };

    getHref(locale) {
        let url = getWindowLocationOrigin() + root.location.pathname + root.location.search;
        const lang = locale.lang.replace(/_/, '-');
        if (url.indexOf('lang=') > -1) {
            url = url.replace(/lang=[\w_-]*/, `lang=${lang}`);
        } else if (url.indexOf('?') > -1) {
            url += `&lang=${lang}`;
        } else {
            url += `?lang=${lang}`;
        }

        return url + root.location.hash;
    }

    render() {
        const {supportedLocales, locale, messages} = this.props;
        if (!supportedLocales || !supportedLocales.length || supportedLocales.length === 1) {
            console.warn('SupportedLocales array was invalid or empty. Hiding locale...');
            return null;
        }
        const {currentLocale, locales} = getCurrentLocale(
            supportedLocales,
            locale,
            messages.locale
        );
        return (
            <div id="locale" className={styles.locale}>
                <div className={styles.icon} title={getMessage(messages, currentLocale)}>
                    <Icon icon={svgs.SPHERE} size={sizes.XSMALL} />
                </div>
                <ul>
                    {locales.map((item, i) => {
                        if (item.lang && item.lang !== locale && item.name) {
                            const href = this.getHref(item);
                            const lang = item.lang.replace(/_/, '-');
                            return (
                                <li key={`lang-${lang}`} data-lang={lang}>
                                    <a
                                        href={href}
                                        onClick={this.onClick}
                                        data-index={i}
                                        className="text-color-hover text-color-nonactive">
                                        <span>
                                            <Message code={item.name} />
                                        </span>
                                    </a>
                                </li>
                            );
                        }
                        if (process.env.NODE_ENV !== 'production') {
                            console.warn(
                                'locale object had an invalid [name] or [lang]! Ensure that the localeOptions are correct.'
                            );
                        }
                        return null;
                    })}
                </ul>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Locale);
